export const MALAY = 'ms';
export const ENGLISH = 'en-US';
export const CHINESE = 'cn';
